import { makeStyles } from "@material-ui/core";

export const GRADE_COLORS = {
    '4.0': '#43a047',
    '3.5': '#1e88e5',
    '3.0': '#fb8c00',
    '2.5': '#ef5350',
    '2.0': '#ab47bc',
    '1.5': '#607d8b',
    '1.0': '#607d8b',
};

export const gradeDeltaDashboardStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        background: '#f5f6fa',
        minHeight: '100%',
    },
    header: {
        marginBottom: theme.spacing(3),
    },
    title: {
        fontWeight: 700,
        fontSize: '1.5rem',
        color: '#1a237e',
    },
    subtitle: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5),
        fontSize: '0.9rem',
    },
    cardsRow: {
        display: 'flex',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
        flexWrap: 'wrap',
    },
    gradeCard: {
        flex: '1 1 180px',
        borderRadius: 8,
        background: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
        overflow: 'hidden',
    },
    gradeCardBar: {
        height: 6,
    },
    gradeCardBody: {
        padding: theme.spacing(2),
    },
    gradeCardLabel: {
        fontWeight: 600,
        fontSize: '0.85rem',
        marginBottom: theme.spacing(0.5),
    },
    gradeCardPrice: {
        fontWeight: 700,
        fontSize: '1.4rem',
        color: '#1a1a2e',
        marginBottom: 2,
    },
    gradeCardVsAppraisal: {
        fontSize: '0.8rem',
        color: '#b71c1c',
    },
    tableWrapper: {
        background: '#fff',
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        overflow: 'hidden',
    },
    table: {
        minWidth: 800,
    },
    tableHead: {
        backgroundColor: '#f0f2ff',
    },
    tableHeadCell: {
        fontWeight: 700,
        fontSize: '0.8rem',
        color: '#3949ab',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        whiteSpace: 'nowrap',
        borderBottom: '2px solid #c5cae9',
    },
    gradeIndicator: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        margin: '-10px 0 -10px -10px',
        height: 'calc(100% + 20px)',
    },
    gradeColorBar: {
        width: 6,
        alignSelf: 'stretch',
        flexShrink: 0,
    },
    gradeValue: {
        fontWeight: 700,
        fontSize: '1rem',
    },
    soldPriceCell: {
        fontWeight: 700,
        fontSize: '0.95rem',
    },
    netToClientCell: {
        fontWeight: 600,
        color: '#2e7d32',
    },
    metricCell: {
        whiteSpace: 'nowrap',
        color: '#424242',
    },
}));
